module.exports = __webpack_public_path__ + "static/media/plus.89626dd1.svg";